import React from 'react'

import { Metric, MetricLabel, MetricValue, Summary } from './styled'

export default function MetricSummary({ facets, formatCount, total, t }) {
  return (
    <Summary aria-label={t('competitive_intelligence_research_summary')}>
      <Metric>
        <MetricValue>{formatCount(total)}</MetricValue>
        <MetricLabel>{t('competitive_intelligence_research_total_records')}</MetricLabel>
      </Metric>
      {facets.sources.map(source => (
        <Metric key={source.key}>
          <MetricValue>{formatCount(source.count)}</MetricValue>
          <MetricLabel>{source.label}</MetricLabel>
        </Metric>
      ))}
    </Summary>
  )
}
